import React from 'react';

import {
  Flex,
  icons,
} from 'web-styled';

import {
  Button,
  EntityIcon,
} from 'web-components';

import * as S from './styled';

const LinkTo = {
  programs: '/personal_programs',
  workouts: '/personal_workouts',
  documents: '/documents',
  exercises: 'exercises',
};

type Props = {
  items: any,
  tabName: string,
  emptyState: React.ReactNode,
  onRequestArchive: { (): void },
  onRequestRestore: { (): void },
  onRequestDeleteItem: { (): void },
};

const ClientDetailsList = ({
  items,
  tabName,
  emptyState,
  onRequestArchive,
  onRequestRestore,
  onRequestDeleteItem,
}: Props) => (items.length > 0 ? (
  items.map(item => (
    <S.Item
      key={item.id}
    >
      <Flex
        spacing={10}
        fillSpace
        align="center"
        justify="space-between"
      >
        <Flex
          align="center"
          justify="center"
          spacing={10}
        >
          <Flex
            width="18px"
            height="20px"
            align="center"
            justify="center"
          >
            <EntityIcon
              resourceType={tabName}
              inactive={item.status === 'inactive'}
            />
          </Flex>
          <S.Name
            inactive={item.status === 'inactive' ? 1 : 0}
            to={`${LinkTo[tabName]}/${item.id}`}
          >
            {item.name}
          </S.Name>
        </Flex>
        <Flex
          align="center"
          className="actions"
          spacing={10}
        >
          {onRequestRestore && (
            <Button
              ghost
              appearance="primary"
              onClick={() => (item.status === 'inactive'
                ? onRequestRestore(item.id)
                : onRequestArchive(item.id)
              )}
            >
              {item.status === 'inactive' ? 'Restore' : 'Archive'}
            </Button>
          )}
          {onRequestDeleteItem && (tabName !== 'exercises' || item.is_single_exercise) && (
            <Button
              ghost
              appearance="danger"
              onClick={() => onRequestDeleteItem(item.id)}
            >
              Unassign
            </Button>
          )}
        </Flex>
      </Flex>
    </S.Item>
  ))) : (
    <S.Empty>
      <S.EmptyIcon
        src={icons[`${tabName}Empty`]}
        alt=""
      />
      {emptyState}
    </S.Empty>
));

export default ClientDetailsList;
